import styled from 'styled-components'
import { Spinner } from '@chakra-ui/react'
import React, { forwardRef } from 'react'

export const Select = forwardRef<
  HTMLSelectElement,
  React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>
>(({ className = '', ...props }, ref) => (
  <select
    className={`mx-1 w-16 rounded border border-gray-300 p-2 ${className}`}
    {...props}
    ref={ref}
  />
))

export const Loader = () => (
  <div className='flex h-screen w-full items-center justify-center'>
    <Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='blue.500' size='xl' />
  </div>
)

export const DragHandle = styled.span`
  display: inline-block;
  cursor: move;
  cursor: grab;

  &::before {
    background-image: radial-gradient(rgba(0, 0, 0, 0.5), transparent 40%);
    background-size: 4px 4px;
    background-position: 0 100%;
    background-repeat: repeat;
    content: '';
    display: block;
    width: 100%;
    height: 100%;
  }
`

export { Button } from './Button'
export { Modal } from './Modal'
export { SmallButton } from './SmallButton'
export { Spinner } from './Spinner'
export { MicButtonAudioOverlay } from './MicButtonAudioOverlay'
export * from '.'
